module.exports = __webpack_public_path__ + "media/images/icons/icon-arrow-right-787fbf40a2cda0b009440ceb62aa46fa.svg";